<template lang="html">

    <section class="slider-home" :min="min">

        <slick ref="slick" :options="slickOptions">
            <article class="slide">
                <div class="intro column-center" data="1">
                    <h1>La unión hace la fuerza</h1>
                    <h3>Una mirada al cooperativismo agroalimentario, al campo y su economía</h3>
                </div>
            </article>
        </slick>


    </section>

</template>

<script lang="js">

    import Slick from 'vue-slick';



    export default {
        name: 'slider-home',
        components: { Slick },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 1,
                },
                min : false
            };
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/slider-home.vue